import ReactAudioPlayer from 'react-audio-player';
import AskSinging from '../assets/audio/student_sing_prompt.mp3';
import { Button } from 'react-bootstrap';
import './SingingDecision.scss';

const SingingDecision = ({ onYesClick, onNoClick }) => {
  return (
    <section className='sing-decision'>
      <ReactAudioPlayer src={AskSinging} autoPlay />
      <h1>Do you want to sing?</h1>
      <main>
        <Button variant='success' onClick={onYesClick}>
          Yes
        </Button>
        <Button variant='danger' onClick={onNoClick}>
          No
        </Button>
      </main>
    </section>
  );
};

export default SingingDecision;
